/*
 *  I17INFPARCONSEPCalcul.js
 *
 *  Created by Sébastien Hecart on 2018-08-05 14:21:23 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */
import { I17INFPARCONSEP_State } from '@batical/types/src'

//TODO IF REQUIREDimport {} from '@batical/types/src';
function I17INFPARCONSEP_docalcul(state: I17INFPARCONSEP_State, isWeb = false): I17INFPARCONSEP_State {
  //TODO CALCUL

  let miData1 = 10000000
  let miData2 = 10000000
  let maData1 = 0
  let maData2 = 0

  let dLine1 = []
  let dLine2 = []
  for (let i = 0; i <= 10; i++) {
    const stepValue = i * 10
    const rendElecRef = ((0.851 * stepValue) / 100 + 0.888 * (1 - stepValue / 100)) * 53.5

    const ep = 1 - 1 / (state.in_rendThermiqueModule / 100 / 0.92 + state.in_rendElecModule / 100 / (rendElecRef / 100))
    const prixC16 = 54 + 1.26 * state.in_tarif + 130 * (ep - 0.1)
    if (!isWeb) {
      miData1 = Math.min(miData1, prixC16)
      maData1 = Math.max(maData1, prixC16)
      miData2 = Math.min(miData2, ep * 100)
      maData2 = Math.max(maData2, ep * 100)
      dLine1.push({ x: stepValue, y: prixC16 })
      dLine2.push({ x: stepValue, y: ep * 100 })
    } else {
      dLine1.push({ x: stepValue, y: Math.round(prixC16 * 100) / 100 })
      dLine2.push({ x: stepValue, y: Math.round(ep * 100 * 100) / 100 })
    }
  }
  state.minData1 = miData1
  state.minData2 = miData2
  state.maxData1 = maData1
  state.maxData2 = maData2
  state.lineData1 = dLine1
  state.lineData2 = dLine2

  state.lineData1Web = [{ id: 'Prix C16', color: '#4277b9', data: dLine1 }]
  state.lineData2Web = [{ id: 'Ep %', color: '#00A790', data: dLine2 }]
  return state
}

export default I17INFPARCONSEP_docalcul
